<button (click)="handleCancelar()" *ngIf="mostrar && !ocultarBotonSecundario">
  Cancelar
</button>
<button (click)="handleGuardar()" class="boton-guardar-cambios" *ngIf="mostrar" [disabled]="deshabilitado">
  {{textoBotonPrincipal || "Guardar Cambios"}}
</button>
